import React from 'react';
import {View} from 'react-native';
import {IStateProps} from './model';
import {CreateRequestForm} from '../form';
import Screen from '../../../../../shared/components/screen';
import {useStyles} from '../../../../../shared/hooks/styles';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({onSuccessFormSubmit}: IStateProps) => {
  const styles = useStyles(() => ({
    sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='never'>
        <View style={styles.sectionContainer}>
          <CreateRequestForm onSuccessSubmit={onSuccessFormSubmit} />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
